import BaseElement from './BaseElement';
import GlobalSearch from '../Components/GlobalSearch/GlobalSearch';
class GlobalSearchElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = GlobalSearch;
    }
}
export default GlobalSearchElement;
